import Link from 'next/link'
import { FC, useState } from 'react'

// eslint-disable-next-line no-var, @typescript-eslint/no-explicit-any
declare var $zopim: any

const HelperBtn: FC = () => {
  const [toggle, setToggle] = useState(false)
  const handleClick = () => {
    setToggle((current) => !current)
  }
  const onClickChat = () => {
    if (
      typeof $zopim !== 'undefined' &&
      typeof $zopim.livechat !== 'undefined'
    ) {
      $zopim.livechat.window.show()
      setToggle(false)
    }
  }
  return (
    <div className={toggle ? 'zoom zoomfull' : 'zoom'}>
      <div
        className={
          toggle
            ? 'zoom-menu more zoom-btn-sm scale-out'
            : 'zoom-menu more zoom-btn-sm'
        }
      >
        <button
          className="zoom-fab zoom-btn-large"
          onClick={handleClick}
          id="zoomBtn"
        >
          {!toggle ? (
            <i className="btm-rt-que">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="100px"
                height="100px"
                viewBox="0 0 100 100"
                version="1.1"
                className="svg replaced-svg"
              >
                <g id="faq">
                  <path
                    d="M50 0C22.4292 0 0 22.4292 0 50C0 77.5708 22.4292 100 50 100C77.5708 100 100 77.5708 100 50C100 22.4292 77.5708 0 50 0ZM54.1667 56.4625C54.1667 54.8417 55.1208 53.3542 56.5958 52.675C63.8667 49.3208 68.75 41.0458 68.75 35.4167C68.75 25.0792 60.3375 16.6667 50 16.6667C39.6625 16.6667 31.25 25.0792 31.25 35.4167C31.25 37.7167 33.1125 39.5833 35.4167 39.5833C37.7208 39.5833 39.5833 37.7167 39.5833 35.4167C39.5833 29.675 44.2542 25 50 25C55.7458 25 60.4167 29.675 60.4167 35.4167C60.4167 37.9625 57.35 43.15 53.1042 45.1042C48.6917 47.1417 45.8333 51.6 45.8333 56.4625L45.8333 58.3333C45.8333 60.6333 47.6958 62.5 50 62.5C52.3042 62.5 54.1667 60.6333 54.1667 58.3333L54.1667 56.4625ZM50 79.1667C47.7 79.1667 45.8333 77.3 45.8333 75C45.8333 72.7 47.7 70.8333 50 70.8333C52.3 70.8333 54.1667 72.7 54.1667 75C54.1667 77.3 52.3 79.1667 50 79.1667Z"
                    id="Shape"
                    fill="#FFFFFF"
                    fillRule="evenodd"
                    stroke="none"
                  />
                </g>
              </svg>
            </i>
          ) : (
            <i className="btm-rt-arw">
              <svg
                version="1.1"
                id="Layer_1"
                xmlns="http://www.w3.org/2000/svg"
                x="0px"
                y="0px"
                viewBox="0 0 18 18"
              >
                <g id="Shape_2_copy_2">
                  <g>
                    <path
                      d="M17.5,15.3L11.3,9l6.2-6.3c0.6-0.6,0.6-1.6,0-2.3c-0.6-0.6-1.6-0.6-2.3,0L9,6.7L2.7,0.5
			c-0.6-0.6-1.6-0.6-2.3,0c-0.6,0.6-0.6,1.6,0,2.3L6.7,9l-6.2,6.3c-0.6,0.6-0.6,1.6,0,2.3C0.8,17.8,1.2,18,1.6,18s0.8-0.2,1.1-0.5
			L9,11.3l6.2,6.3c0.3,0.3,0.7,0.5,1.1,0.5c0.4,0,0.8-0.2,1.1-0.5C18.2,16.9,18.2,15.9,17.5,15.3z"
                      fill="#fff"
                    />
                  </g>
                </g>
              </svg>
            </i>
          )}
        </button>
        <div className="zoom-wheel">
          <span className="zoom-action-1">
            <Link href="tel:+1-978-309-9910" aria-label="Call Us">

              {' '}
              <i>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="100px"
                  height="100px"
                  viewBox="0 0 100 100"
                  version="1.1"
                  className="svg replaced-svg"
                >
                  <desc>Created with Lunacy</desc>
                  <defs>
                    <path d="M0 0L100 0L100 100L0 100L0 0Z" id="path_1" />
                  </defs>
                  <g id="call">
                    <path
                      d="M0 0L100 0L100 100L0 100L0 0Z"
                      id="Background"
                      fill="none"
                      stroke="none"
                    />
                    <g clipPath="url(#mask_1)">
                      <g
                        id="Group"
                        transform="translate(3.4015503 -0.00048828125)"
                      >
                        <path
                          d="M82.7605 69.6006C76.7195 64.4337 70.5888 61.304 64.6219 66.463L61.059 69.581C58.4522 71.8445 53.6053 82.4201 34.8658 60.863C16.1302 39.3333 27.2795 35.9811 29.8902 33.7372L33.4727 30.6152C39.4083 25.4445 37.1683 18.9352 32.8873 12.2347L30.3039 8.17618C26.0034 1.4913 21.3205 -2.89894 15.3692 2.26398L12.1536 5.07374C9.52339 6.98984 2.17119 13.2181 0.387775 25.0503C-1.75857 39.2474 5.01217 55.505 20.5244 73.343C36.017 91.1889 51.1858 100.153 65.5546 99.9967C77.4961 99.8679 84.7078 93.4601 86.9634 91.1303L90.1907 88.3167C96.1263 83.1576 92.4385 77.905 86.3936 72.7264L82.7605 69.6006L82.7605 69.6006Z"
                          id="Shape"
                          fill="#FFFFFF"
                          stroke="none"
                        />
                      </g>
                    </g>
                  </g>
                </svg>
              </i>

            </Link>
          </span>
          <span className="zoom-action-2">
            <Link
              href="https://mail.google.com/mail/u/0/?fs=1&amp;tf=cm&amp;to=sales@webcluesinfotech.com"
              target="_blank"
              aria-label="Email Us">

              <i>
                {' '}
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="100px"
                  height="100px"
                  viewBox="0 0 100 100"
                  version="1.1"
                  className="svg replaced-svg"
                >
                  <desc>Created with Lunacy</desc>
                  <defs>
                    <path d="M0 0L100 0L100 100L0 100L0 0Z" id="path_1" />
                  </defs>
                  <g id="email">
                    <path
                      d="M0 0L100 0L100 100L0 100L0 0Z"
                      id="Background"
                      fill="none"
                      stroke="none"
                    />
                    <g clipPath="url(#mask_1)">
                      <g id="Group" transform="translate(64.78693 20.678894)">
                        <g id="Group">
                          <path
                            d="M35.1535 0L0 29.2725L35.2131 52.7074L35.2131 0.659765C35.2131 0.434765 35.1898 0.215234 35.1535 0L35.1535 0Z"
                            id="Shape"
                            fill="#FFFFFF"
                            stroke="none"
                          />
                        </g>
                      </g>
                      <g id="Group" transform="translate(0 52.590637)">
                        <g id="Group">
                          <path
                            d="M61.6172 0L57.1857 3.69004C55.1039 5.42364 52.552 6.29043 50.0002 6.29043C47.4484 6.29043 44.8963 5.42364 42.8146 3.69004L38.3832 0L0 25.5447L0 26.0709C0 28.2508 1.77363 30.0244 3.95352 30.0244L96.0463 30.0244C98.2262 30.0244 99.9998 28.2508 99.9998 26.0709L99.9998 25.5447L61.6172 0L61.6172 0Z"
                            id="Shape"
                            fill="#FFFFFF"
                            stroke="none"
                          />
                        </g>
                      </g>
                      <g
                        id="Group"
                        transform="translate(3.3490295 17.385132)"
                      >
                        <g id="Group">
                          <path
                            d="M92.7119 0C92.707 0 92.7021 0 92.6974 0L0.604477 0C0.599594 0 0.594907 0 0.590024 0C0.0318207 0.00214875 -0.209781 0.713281 0.219125 1.07051L36.4068 31.2041C36.4111 31.2076 36.4154 31.2113 36.4197 31.2148L41.9953 35.8576C44.693 38.1041 48.6092 38.1041 51.3068 35.8576L93.0828 1.07051C93.5117 0.713086 93.2699 0.00195354 92.7119 0L92.7119 0Z"
                            id="Shape"
                            fill="#FFFFFF"
                            stroke="none"
                          />
                        </g>
                      </g>
                      <g id="Group" transform="translate(0 20.678894)">
                        <g id="Group">
                          <path
                            d="M0.0595703 0C0.0232422 0.215234 0 0.434375 0 0.659765L0 52.7074L35.2131 29.2723L0.0595703 0L0.0595703 0Z"
                            id="Shape"
                            fill="#FFFFFF"
                            stroke="none"
                          />
                        </g>
                      </g>
                    </g>
                  </g>
                </svg>
              </i>

            </Link>
          </span>{' '}
          <span className="zoom-action-3">
            <Link
              href="https://api.whatsapp.com/send?l=en&amp;text=Hi%20I%20am%20interested%20in%20one%20of%20your%20service%20at%20WebClues%20Infotech&amp;phone=918141068282"
              target="_blank"
              aria-label="WhatsApp Chat">

              <i>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="100px"
                  height="100px"
                  viewBox="0 0 100 100"
                  version="1.1"
                  className="svg replaced-svg"
                >
                  <desc>Created with Lunacy</desc>
                  <g id="whatsapp">
                    <path
                      d="M0 50C0 22.5372 22.5372 0 50 0C77.4628 0 100 22.5372 100 50C100 77.4628 77.4628 100 50 100C40.9363 100 32.1129 97.5563 24.3935 92.9222L0 100L7.07779 75.6065C2.4437 67.8871 0 59.0637 0 50ZM78.9345 73.4528L81.2607 71.1266C82.5722 69.8143 82.5241 67.7299 81.2607 66.4719L71.9566 57.1678C70.7458 55.9563 68.5028 55.9601 67.3019 57.1678L64.9757 59.4933C62.4008 62.0674 58.2397 62.0644 55.6686 59.4933L40.3008 44.3275C37.7373 41.7641 37.7373 37.59 40.3008 35.0204L42.6262 32.692C43.2472 32.0732 43.5875 31.2492 43.5875 30.368C43.5875 29.4868 43.2472 28.6636 42.6262 28.0426L33.3199 18.7355C32.0374 17.4538 29.9515 17.4522 28.6674 18.7355L26.3412 21.0617C23.7411 23.6626 22.747 30.4787 24.5476 38.3186C28.1837 54.1451 47.0383 72.4205 63.2103 75.544C68.074 76.4832 75.6432 76.7441 78.9345 73.4528Z"
                      id="Shape"
                      fill="#FFFFFF"
                      fillRule="evenodd"
                      stroke="none"
                    />
                  </g>
                </svg>
              </i>

            </Link>
          </span>
          <span className="zoom-action-4">
            <a
              aria-hidden="true"
              aria-label="Live Chat"
              className="phplive_btn_1453967008"
              onClick={(e) => onClickChat()}
            >
              <i>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="100px"
                  height="100px"
                  viewBox="0 0 100 100"
                  version="1.1"
                  className="svg replaced-svg"
                >
                  <desc>Created with Lunacy</desc>
                  <defs>
                    <path d="M0 0L100 0L100 100L0 100L0 0L0 0Z" id="path_1" />
                  </defs>
                  <g id="livechat">
                    <g id="talk-expert-iccon">
                      <path
                        d="M0 0L100 0L100 100L0 100L0 0L0 0Z"
                        id="Background"
                        fill="none"
                        stroke="none"
                      />
                      <g id="Mask-group">
                        <path
                          d="M0 0L100 0L100 100L0 100L0 0L0 0Z"
                          id="path_1"
                          fill="none"
                          stroke="none"
                        />
                        <g clipPath="url(#mask_1)">
                          <g id="Group" transform="translate(0 1.4170448)">
                            <g id="Group">
                              <path
                                d="M100 51.139L100 60.895C100 65.7977 96.0293 69.766 91.1293 69.766L84.6903 69.766C78.3123 87.478 62.0243 98.1757 49.9977 98.1757C37.9707 98.1757 21.6829 87.4757 15.3049 69.766L8.87073 69.766C3.97073 69.766 0 65.7977 0 60.895L0 51.139C0 47.7683 1.88049 44.8367 4.65123 43.334C4.7439 29.4804 8.7805 18.661 16.6683 11.1829C24.4927 3.7634 35.7073 0 50 0C64.2927 0 75.5073 3.76097 83.3317 11.1805C91.217 18.661 95.256 29.4804 95.3513 43.334C98.1194 44.834 100 47.7683 100 51.139ZM50 5.32196C75.6463 5.32196 89.444 18.0927 90.0073 42.2683L86.5977 42.2683C85.3513 34.1197 82.7123 27.4195 78.7073 22.2659C72.3243 14.0561 62.6683 9.8927 50 9.8927C37.3317 9.8927 27.6732 14.0561 21.2927 22.2659C17.2878 27.4195 14.6512 34.1197 13.4025 42.2683L9.99026 42.2683C10.5561 18.0927 24.3537 5.32196 50 5.32196ZM80.9367 47.527C81.1097 49.605 81.2267 51.7463 81.2267 54.034C81.2267 78.578 60.5977 91.9633 50 91.9633C43.256 91.9633 32.456 86.5317 25.4902 76.266C30.444 78.605 36.0023 79.4683 41.0587 79.7587C42.3073 82.0463 45.4267 83.6707 49.0853 83.6707C53.844 83.6707 57.7 80.9317 57.7 77.5537C57.7 74.1757 53.844 71.4367 49.0853 71.4367C45.5757 71.4367 42.561 72.927 41.2197 75.066C33.983 74.6197 25.8097 72.9317 20.861 66.9633C19.5488 63.0757 18.7756 58.7633 18.7756 54.034C18.7756 52.734 18.8219 51.4903 18.878 50.261C27.6878 49.0293 35.622 40.3023 35.8633 29.1073C35.8853 28.1321 36.1697 28.5462 36.9235 29.6441L36.924 29.6449C37.1768 30.0132 37.4827 30.4584 37.8487 30.9537C37.8537 30.9587 37.856 30.9633 37.861 30.9683C38.2123 31.444 38.6196 31.9633 39.0903 32.5073C47.2927 42.2487 58.1367 41.2123 63.661 45.5633C63.0414 43.2587 62.017 41.5073 60.834 40.1757C69.8537 41.1927 77 43.9243 80.9367 47.527ZM62.9877 48.866C60.1513 48.866 57.8537 51.161 57.8537 54C57.8537 56.834 60.1513 59.134 62.9877 59.134C65.822 59.134 68.122 56.834 68.122 54C68.122 51.1683 65.822 48.866 62.9877 48.866ZM42.1463 54.0023C42.1463 56.8367 39.8487 59.1367 37.0123 59.1367C34.1757 59.1367 31.878 56.8367 31.878 54.0023C31.878 51.1633 34.1757 48.8683 37.0123 48.8683C39.8487 48.866 42.1463 51.1683 42.1463 54.0023Z"
                                id="Shape"
                                fill="#FFFFFF"
                                fillRule="evenodd"
                                stroke="none"
                              />
                            </g>
                          </g>
                        </g>
                      </g>
                    </g>
                  </g>
                </svg>
              </i>
            </a>
          </span>
        </div>
      </div>
    </div>
  );
}
export default HelperBtn
